export var FETCH_SOCKET_CONNECT_REQUEST = 'FETCH_SOCKET_CONNECT_REQUEST';
export var FETCH_SOCKET_CONNECT_SUCCESS = 'FETCH_SOCKET_CONNECT_SUCCESS';
export var FETCH_SOCKET_CONNECT_FAILURE = 'FETCH_SOCKET_CONNECT_FAILURE';
export var RECEIVE_SOCKET_EVENT = 'RECEIVE_SOCKET_EVENT';
export var FETCH_SEND_SOCKET_EVENT_REQUEST = 'FETCH_SEND_SOCKET_EVENT_REQUEST';
export var FETCH_SEND_SOCKET_EVENT_SUCCESS = 'FETCH_SEND_SOCKET_EVENT_SUCCESS';
export var FETCH_SEND_SOCKET_EVENT_ERROR = 'FETCH_SEND_SOCKET_EVENT_ERROR';
export var FETCH_SOCKET_DISCONNECT_REQUEST = 'FETCH_SOCKET_DISCONNECT_REQUEST';
export var FETCH_SOCKET_DISCONNECT_SUCCESS = 'FETCH_SOCKET_DISCONNECT_SUCCESS';
export var FETCH_SOCKET_DISCONNECT_FAILURE = 'FETCH_SOCKET_DISCONNECT_FAILURE';